import { useState } from "react";

const useEditorActions = (setInputCode, outputCode, setOutputCode) => {

  // Download file (accepts type & fileName)
  const handleDownload = (type = "json", fileName = "formatted") => {
    if (!outputCode) return;
    const blob = new Blob([outputCode], { type: `application/${type}` });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${fileName}.${type}`;
    link.click();
    URL.revokeObjectURL(url);
  };

  // Clear editors
  const handleClear = () => {
    setInputCode("");
    setOutputCode("");
  };

  return {
    handleDownload,
    handleClear
  };
};

export default useEditorActions;
